/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.14.1
 * @since 1.14.1
 */

import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "WizardBillsDoc" */ './components/WizardBillsDoc'));
